import React from 'react'
import { FaArrowRight, FaStar } from 'react-icons/fa'
function CS_Review_Program_Page() {
  return (
    <div>
    <div>
      <div className='container'>
      <div className='row d-sm-block d-md-none'>
            <div className='col-md-1'></div>
            <div className='col-md-10'>
            <div className='text-center review_component_text'>
                <h1 className='display-5 pb-2'>Testmonial</h1>
                <p className='fs-6'>Listen to the people who have made it! Explore the testimonies of former students who attested to the life-altering effects of their educational experiences.</p>
            </div>
            </div>
            <div className='col-md-1'></div>
        </div>
        <div className='row'>
            <div className='col-md-4 pt-5'>
                <div className='Program_review_comp'>
                    <div className='mt-5 px-5 review_component_text'>
                        <h1 className='pt-5 display-6'>Hear What Our Students Says</h1>
                        <p className='pt-4 fs-5'>25K+ Students have already learned with InternsElite</p>
                    </div>
                </div>
            </div>
            <div className='col-md-8'>
                <div className='row'>
                <div class="col-md-5 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Mithilesh Rajendra Jogale</h5>
                    <h6 class="font-weight-bold my-2">NMI of Engineering and Technology, CSE</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar />
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>Internship was  very good the  task assigned were nice and we learned so many new things from it.
                    </p>
                </div>
                </div>
                <div class="col-md-7 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Rakshita Sharma</h5>
                    <h6 class="font-weight-bold my-2">Vellore Institute of Technology-Bhopal, (CSE)</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>The cyber security training and internship program is well-structured, providing a comprehensive curriculum covering various technical skills needed in the field of cyber security. 
                    </p>
                </div>
                </div>
                <div class="col-md-6 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Aryan Sharma</h5>
                    <h6 class="font-weight-bold my-2">AIMETC, Jalandhar, Punjab</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar />
                    </li>
                    </ul>
                    <p class="mb-2">
                    <i class="fas fa-quote-left pe-2"></i>Absolutely good course learned various things like burpsuit, networking, projects 
                    </p>
                </div>
                </div>
                <div class="col-md-6 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">A. Jotheeswar</h5>
                    <h6 class="font-weight-bold my-2">SGS ARTS COLLEGE, Bsc Computer Science</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>"The explanation on course basic concepts are well but I expected more than those yet learnt by myself. Overall course is satisfactory with 3 star rating"
                    </p>
                </div>
                </div>
                <div class="col-md-7 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Shubham S. Shinde</h5>
                    <h6 class="font-weight-bold my-2">MET BKC Institute of Engineering, Nashik</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar />
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>Aman Gupta sir's two-month cyber security training was exceptionally informative, blending practical insights with engaging teaching. His expertise, timely clarifications, and focus on governance in cyber incident response were invaluable, making the program impactful and relevant.
                    </p>
                </div>
                </div>
                <div class="col-md-5 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Acitya Kumar</h5>
                    <h6 class="font-weight-bold my-2">NOIDA INTERNATIONAL UNIVERSITY (BCA)</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    <li>
                    <FaStar color={"gold"}/>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>The internship program went really well and it was really good. The mentors were really good and knowledgeable. I fully satisfied and had a good experience with this Internship program with the Interns Elite.
                    </p>
                </div>
                </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    </div>
  )
}

export default CS_Review_Program_Page
